import { StepSchema, StepType } from '@feedyou/schema'

// Define a type for the returned type guard function
type StepTypeGuard<T extends StepType> = (
  step?: StepSchema
) => step is Extract<StepSchema, { type: T }>

export const isOfType = <T extends StepType>(type: T | T[]): StepTypeGuard<T> => {
  return (step?: StepSchema): step is Extract<StepSchema, { type: T }> => {
    if (Array.isArray(type)) {
      return type.some(t => isOfType(t)(step))
    }

    return step?.type === type
  }
}
